import React from "react";
import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema";
import { usePortSecurityFormStore } from "@features/port-security/store/usePortSecurityForm.store.ts";
import { redirectForTranslateFromEnglishToArabic } from "@utils/translateFromEnglishToArabic.ts";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const SponsorData: React.FC = () => {
  const { formData, updateFormData } = useOutletContext<FormContext>();
  const occupationEnglish = usePortSecurityFormStore((state) => state.occupation);

  const handleActionClicked = () => {
    redirectForTranslateFromEnglishToArabic(occupationEnglish);
  };

  return (
    <FormProvider {...formData}>
      <FormSection title={t("security-clearance.sponsor-data")}>
        <div className="md:col-span-full">
          <FormItem<PortSecurityFormData, "currentSponsor">
            name="currentSponsor"
            type="text"
            maxChars={200}
            label={t("security-clearance.current-sponsor")}
            testId="security-currentSponsor"
            onFieldChange={updateFormData}
          />
        </div>
        <FormItem<PortSecurityFormData, "occupation">
          name="occupation"
          type="text"
          maxChars={200}
          label={t("security-clearance.occupation")}
          testId="security-occupation"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "occupationAr">
          name="occupationAr"
          dir="rtl"
          type="text"
          maxChars={200}
          label={t("security-clearance.occupation-ar")}
          testId="security-occupationAr"
          onFieldChange={updateFormData}
          actionInLabel
          textForActionInLabel={t("security-clearance.translate")}
          onActionClicked={handleActionClicked}
        />
        <FormItem<PortSecurityFormData, "officeFax">
          name="officeFax"
          maxChars={20}
          type="text"
          label={t("security-clearance.office-fax")}
          testId="security-officeFax"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "presentWorkplace">
          name="presentWorkplace"
          type="text"
          maxChars={200}
          label={t("security-clearance.present-workplace")}
          testId="security-presentWorkplace"
          onFieldChange={updateFormData}
          timePicker={false}
        />
        <FormItem<PortSecurityFormData, "bank">
          name="bank"
          type="text"
          maxChars={200}
          label={t("security-clearance.bank")}
          testId="security-bank"
          onFieldChange={updateFormData}
          timePicker={false}
        />
        <FormItem<PortSecurityFormData, "officeTelephone">
          name="officeTelephone"
          type="text"
          maxChars={20}
          label={t("security-clearance.office-telephone")}
          testId="security-officeTelephone"
          onFieldChange={updateFormData}
          timePicker={false}
        />
        <FormItem<PortSecurityFormData, "salary">
          name="salary"
          type="text"
          maxChars={200}
          label={t("security-clearance.salary")}
          testId="security-salary"
          onFieldChange={updateFormData}
          timePicker={false}
        />
      </FormSection>
    </FormProvider>
  );
};

export default SponsorData;
